import { CreateEditSellForm } from '@/components/Pages/Sells/Create/CreateEditSellForm';
import { createFileRoute, Link, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { Stack, Breadcrumbs } from '@mui/joy';
import { SellEditProvider } from '@/contexts/SellEditContext';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/sells/create')({
  component: CreateSell,
  head: () => pageTitle('Crear venta'),
});

function CreateSell() {
  const { hasClaim, isLoading } = useAuth();
  const canWrite = hasClaim('SELLS_WRITE');

  if (!isLoading && !canWrite) {
    return <Navigate to='/sells' />;
  }

  return (
    <>
      <Stack direction='row' justifyContent='space-between'>
        <Breadcrumbs size='sm'>
          <Link to='/sells'>Ventas</Link>
        </Breadcrumbs>
      </Stack>

      <SellEditProvider>
        <CreateEditSellForm isCreate />
      </SellEditProvider>
    </>
  );
}
